import React from 'react';
import { Navigate, Route } from 'react-router-dom';

import { UserRolesEnum } from 'commons/types/user.roles.enum';
import PrivateRoute from 'commons/utils/privateRoute';
// import PackAllocationStaging from 'pages/pack/pack-allocation-staging/PackAllocationStaging';
import CheckBasketPage from 'pages/pack/pack-check-basket/CheckBasket';
import PackPrintPage from 'pages/pack/pack-print-page/PackPrintPage';
import PackSummaryPage from 'pages/pack/pack-summary/PackSummaryPage';

import {
  PACK_TASK_ROUTE_ROOT,
  PACK_TASK_ROUTES,
} from './constants/pack-task-routes.constant';

export const usePackTaskRouter = (): React.JSX.Element => (
  <Route
    path={PACK_TASK_ROUTE_ROOT}
    element={
      <PrivateRoute
        roles={[
          UserRolesEnum.ADMIN,
          UserRolesEnum.SUPER_ADMIN,
          UserRolesEnum.PACKER,
          UserRolesEnum.PACKER_LEAD,
          UserRolesEnum.PACKER_SPV,
        ]}
      />
    }
  >
    <Route path={PACK_TASK_ROUTES.PRINT} element={<PackPrintPage />} />
    <Route path={PACK_TASK_ROUTES.SUMMARY} element={<PackSummaryPage />} />
    {/* The page will temporary hidden until further update flow */}
    {/* <Route
      path={PACK_TASK_ROUTES.ALLOCATION_STAGING}
      element={<PackAllocationStaging />}
    /> */}
    <Route path={PACK_TASK_ROUTES.CHECK_BASKET} element={<CheckBasketPage />} />
    <Route path={PACK_TASK_ROUTES.PACK_TASK} element={<Navigate to="/" />} />
    <Route path={PACK_TASK_ROUTES.WILDCARD} element={<Navigate to="/" />} />
  </Route>
);
